/**
 * AWS Cost Explorer API Service
 */

import axiosInstance from './axiosInstance';

/**
 * GET /console/v1/getCostExplorer?resource=<resource>
 * Fetches AWS cost breakdown by service and resource
 *
 * axiosInstance baseURL = REACT_APP_CONSOLE_API + '/v1'
 * Full URL: {base}/console/v1/getCostExplorer  → we override baseURL here
 * to hit the root so the path resolves correctly.
 */
export const getCostExplorer = async ({ resource = 'vivre-dev', startDate, endDate } = {}) => {
  const params = { resource };
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;

  const response = await axiosInstance.get('/console/v1/getCostExplorer', {
    params,
    baseURL: process.env.REACT_APP_CONSOLE_API,
  });
  return response.data;
};
